import { makeStyles, withStyles, Badge } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  MainBody: {
    width: "100%",
    border: "1px solid black",
    margin: "auto",
  },
  border: {
    border: `1.9px solid #E8E8EF`,
  },
  networkError: {
    backgroundColor: theme.palette.secondary.dark,
  },
  LayoutRoot: {
    display: "flex",
    backgroundColor: "#F2F2F6",
    minHeight: "100vh",
  },
  LayoutChildren: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  AppBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: `linear-gradient(to right, ${theme.palette.secondary.dark} ,  ${theme.palette.secondary.main});`,
  },

  Avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  online: {
    backgroundColor: "#44b700",
  },
  offline: {
    backgroundColor: "black",
  },
  datePicker: {
    backgroundColor: "white",
    outline: "none",
    border: "none",
    boxShadow: "0 2px 3px #c1c1c1",
    fontFamily: "dana",
    paddingTop: 8,
    fontSize: 15,
    color: theme.palette.primary.dark,
    height: 25,
    fontWeight: 500,
    borderRadius: 6,
    marginTop: 5,
  },
  Tooltip: {
    backgroundColor: "white",
    color: "black",
    padding: 16,
    borderRadius: 4,
    boxShadow: "0 0 6px #c9c9c9",
    fontSize: 14,
  },
}));

export const StyledBadge = withStyles((theme) => ({
  badge: {
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "$ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}))(Badge);
